import { Symbology } from '@scandit/web-datacapture-barcode'
import type { DataCaptureView } from '@scandit/web-datacapture-core'
import {
  CustomBarcodeBuilder,
  ExpiryDateTextBuilder,
  type LabelCapture,
  LabelCaptureSettings,
  LabelDateFormat,
  LabelDefinitionBuilder,
} from '@scandit/web-datacapture-label'
import type { LabelPreset } from '../LabelCaptureSettingsStore'
import type { BuildSettingsContext, ControllerDeps, PresetController, Teardown } from './PresetController'
import { activateValidationFlow } from './ValidationFlowController'

export class PerishableProductController implements PresetController {
  readonly preset: LabelPreset = 'perishableProduct'

  constructor(private readonly deps: ControllerDeps) {}

  async buildSettings(ctx: BuildSettingsContext): Promise<LabelCaptureSettings> {
    const labelDefinition = await new LabelDefinitionBuilder()
      .addCustomBarcode(
        await new CustomBarcodeBuilder()
          .isOptional(false)
          .setSymbologies([Symbology.EAN13UPCA, Symbology.EAN8, Symbology.Code128])
          .build('SKU')
      )
      .addExpiryDateText(
        await new ExpiryDateTextBuilder()
          .isOptional(true)
          .setLabelDateFormat(new LabelDateFormat(ctx.dateFormat, ctx.acceptPartialDates))
          .resetAnchorRegexes()
          .build('Expiry Date')
      )
      .adaptiveRecognitionMode(ctx.adaptiveRecognitionMode)
      .build('fresh-product')
    return LabelCaptureSettings.fromLabelDefinitions([labelDefinition])
  }

  activate(mode: LabelCapture, view: DataCaptureView): Promise<Teardown> {
    return activateValidationFlow(mode, view, this.deps)
  }

  resume(mode: LabelCapture): Promise<void> {
    return mode.setEnabled(true)
  }
}
